import request from "../api";

export const confirmRequest = (form, type = "confirm") => 
  request("panpartner:requests.ajax",  type === "confirm" ? "confirmRequest" : "cancelRequest", form, true)